if (typeof window.parkside === 'undefined') window.parkside = {};
if (typeof window.parkside.zeichentool === 'undefined') window.parkside.zeichentool = {};

window.parkside.zeichentool.initRotationTool = function() {
  dojo.require('dojo.html');
  dojo.require('dojox.gfx');
  dojo.require('dojox.gfx.Moveable');

  dojo.addOnLoad(function() {
    var container = dojo.byId('canvas'),
      container_position = dojo.position(container, true),
      container_visible_dimension = { w: jQuery('#canvas').width(), h: jQuery('#canvas').height() },
      defaultHeight = jQuery('#canvas').height(), //height to scale the background image
      toolbarPadding = 142,
      zoomMultiplier = 1.2,
      viewData = {
        zoomLevel: 0.0,
        pan: {
          x: 0.0,
          y: 0.0,
        },
        zoomPan: {
          x: 0.0,
          y: 0.0,
        },
        rotation: {
          deg: 0.0,
          deg_abs: 0.0,
          center: {
            x: container_visible_dimension.w / 2.0,
            y: container_visible_dimension.h / 2.0,
          },
        },
      },
      gridStepSize = 50, //grid size in px
      matrix = dojox.gfx.matrix,
      init_matrix = matrix.translate(0, 0),
      s = dojox.gfx.createSurface('canvas');

    s.whenLoaded(function() {
      s.setDimensions(container_visible_dimension.w, container_visible_dimension.h);

      jQuery('#opacity-slider').slider({
        value: 80,
        orientation: 'horizontal',
        range: 'min',
        animate: false,
      });
      jQuery('#opacity-slider').bind('slide', function(event, ui) {
        jQuery('#canvas svg rect').css('opacity', 1 - ui.value / 100);
      });

      var maingroup = false,
        imagegroup = false,
        selectedTool = false,
        moveableObj = false,
        onmoveShapes = [],
        templine = false,
        temppoint = false,
        diffx = 0.0,
        diffy = 0.0,
        drawBackgroundImage = function(group) {
          // draw background image if available
          if (jQuery('#canvas').attr('data-image').length) {
            var newWidth =
              (parseFloat(defaultHeight) * parseFloat(jQuery('#canvas').attr('data-width'))) /
              parseFloat(jQuery('#canvas').attr('data-height'));
            var bildpos = global2local({ x: container_visible_dimension.w / 2.0 - newWidth / 2.0, y: 0.0 });
            if (viewData.zoomLevel != 0.0) {
              group.createImage({
                x: bildpos.x,
                y: bildpos.y,
                width: newWidth * Math.pow(zoomMultiplier, viewData.zoomLevel),
                height: defaultHeight * Math.pow(zoomMultiplier, viewData.zoomLevel),
                src: 'templates/form/vorlage/files/' + jQuery('#canvas').attr('data-image'),
              });
            } else {
              group.createImage({
                x: bildpos.x,
                y: bildpos.y,
                width: newWidth,
                height: defaultHeight,
                src: 'templates/form/vorlage/files/' + jQuery('#canvas').attr('data-image'),
              });
            }
          }

          // var bgrect = group.createRect({ x: 0.0, y: 0.0, width: parseFloat(s.getDimensions().width), height: parseFloat(s.getDimensions().height) }).setFill("#ffffff");
          var bgrect = group
            .createRect({
              x: bildpos.x,
              y: bildpos.y,
              width: newWidth * Math.pow(zoomMultiplier, viewData.zoomLevel),
              height: defaultHeight * Math.pow(zoomMultiplier, viewData.zoomLevel),
            })
            .setFill('#ffffff');

          // Check for IE8. Since no transparency is applied in this browser, move the white background to the back
          if (navigator.appVersion.indexOf('MSIE 8.') != -1) {
            bgrect.moveToBack();
          }

          //apply current transparency value
          jQuery('#canvas svg rect').css('opacity', 1 - jQuery('#opacity-slider').slider('option', 'value') / 100);
        },
        drawGrid = function(group) {
          for (var i = 0; i <= s.getDimensions().width; i += gridStepSize) {
            group
              .createLine({ x1: i, y1: 0, x2: i, y2: s.getDimensions().height })
              .setStroke({ color: '#ccc', width: 1 });
          }

          for (var i = 0; i <= s.getDimensions().height; i += gridStepSize) {
            group
              .createLine({ x1: 0, y1: i, x2: s.getDimensions().width, y2: i })
              .setStroke({ color: '#ccc', width: 1 });
          }
        },
        global2local = function(point) {
          var newpoint = { x: 0.0, y: 0.0 };
          newpoint.x = point.x * Math.pow(zoomMultiplier, viewData.zoomLevel) + viewData.pan.x + viewData.zoomPan.x;
          newpoint.y = point.y * Math.pow(zoomMultiplier, viewData.zoomLevel) + viewData.pan.y + viewData.zoomPan.y;
          return newpoint;
        },
        local2global = function(point) {
          var newpoint = { x: 0.0, y: 0.0 };
          newpoint.x = (point.x - viewData.pan.x - viewData.zoomPan.x) * Math.pow(zoomMultiplier, -viewData.zoomLevel);
          newpoint.y = (point.y - viewData.pan.y - viewData.zoomPan.y) * Math.pow(zoomMultiplier, -viewData.zoomLevel);
          return newpoint;
        },
        switchCursor = function(cursorstyle) {
          dojo.style('canvas', 'cursor', cursorstyle);
        },
        redraw = function(option) {
          s.clear();
          maingroup = s.createGroup();
          maingroup
            .createRect({ x: 0, y: 0, width: container_position.w, height: container_position.h })
            .setFill('#fff');

          imagegroup = maingroup.createGroup().setTransform(init_matrix);
          updateMatrix(imagegroup, option);
          drawBackgroundImage(imagegroup);

          var gridgroup = maingroup.createGroup();
          drawGrid(gridgroup);

          activateMover();
        },
        updateMatrix = function(group, option) {
          var locCenter = global2local(viewData.rotation.center);

          group.setTransform([matrix.rotategAt(viewData.rotation.deg, locCenter.x, locCenter.y)]);
        },
        activateMover = function() {
          moveableObj = new dojox.gfx.Moveable(maingroup);
          dojo.connect(
            moveableObj,
            'onMoved',
            function(mover, shift) {
              viewData.pan.x += shift.dx;
              viewData.pan.y += shift.dy;
              redraw('mover');
            }
          );
        };

      // functions called on page load
      selectedTool = 'mover';
      switchCursor('move');
      redraw();

      var clearOnMoveShapes = function() {
        /*
         * Clear all temporary shapes that are drawn when moving with the drawing tool.
         * (i.e. temporary line)
         */
        if (onmoveShapes.length) {
          for (var i = 0; i < onmoveShapes.length; i++) {
            onmoveShapes[i].removeShape();
            onmoveShapes[i].destroy();
          }
          onmoveShapes.length = 0;
        }
      };

      /*
       * Redraw the surface with a zoomlevel applied.
       * Args:
       *   type: String value "in" or "out" to init a zoom-in or zoom-out process.
       *   zoomPoint: Point object as reference on surface to which the zoom is applied. (= center of surface if left empty)
       */
      var applyZoom = function(type, zoomPoint) {
        if (type === 'in') {
          if (!zoomPoint) {
            var surfaceZoomPoint = {
              x: parseFloat(s.getDimensions().width) / 2.0,
              y: parseFloat(s.getDimensions().height) / 2.0,
            };
          } else {
            var surfaceZoomPoint = zoomPoint;
          }

          var globalDiff = local2global(surfaceZoomPoint);

          viewData.zoomLevel++;

          var f = Math.pow(zoomMultiplier, viewData.zoomLevel) - Math.pow(zoomMultiplier, viewData.zoomLevel - 1.0);
          var diffx = -f * globalDiff.x;
          var diffy = -f * globalDiff.y;

          viewData.zoomPan.x += diffx;
          viewData.zoomPan.y += diffy;

          redraw();
        } else if (type === 'out') {
          viewData.zoomLevel--;

          if (!zoomPoint) {
            var surfaceZoomPoint = {
              x: parseFloat(s.getDimensions().width) / 2.0,
              y: parseFloat(s.getDimensions().height) / 2.0,
            };
          } else {
            var surfaceZoomPoint = zoomPoint;
          }
          var globalDiff = local2global(surfaceZoomPoint);
          var f = Math.pow(zoomMultiplier, viewData.zoomLevel) - Math.pow(zoomMultiplier, viewData.zoomLevel - 1.0);
          var diffx = -f * globalDiff.x;
          var diffy = -f * globalDiff.y;

          viewData.zoomPan.x -= diffx;
          viewData.zoomPan.y -= diffy;

          redraw();
        }
      };

      s.on('mousedown', function(ev) {});

      s.on('mousemove', function(ev) {});

      /* Definition of the actions of the toolbar buttons
			----------------------------------------------------*/

      // jQuery("#clear").bind("click", function () {
      // 	points.length = 0;
      // 	//areas.length = 0;
      // 	data = {};
      // 	polyfinished = false;
      // 	redraw();
      // });
      var timeoutId = 0;
      var intervalId = 0;

      jQuery('#rotate-right')
        .bind('mousedown', function() {
          viewData.rotation.deg += 0.5;
          jQuery('input[name=direct-input-rotation]').val(viewData.rotation.deg.toFixed(1).replace('.', ','));
          redraw();
          timeoutId = setTimeout(function() {
            intervalId = setInterval(function() {
              viewData.rotation.deg += 0.5;
              jQuery('input[name=direct-input-rotation]').val(viewData.rotation.deg.toFixed(1).replace('.', ','));
              redraw();
            }, 100);
          }, 400);
        })
        .bind('mouseup mouseleave', function() {
          clearInterval(intervalId);
          clearTimeout(timeoutId);
        });

      jQuery('#rotate-left')
        .bind('mousedown', function() {
          viewData.rotation.deg -= 0.5;
          jQuery('input[name=direct-input-rotation]').val(viewData.rotation.deg.toFixed(1).replace('.', ','));
          redraw();
          timeoutId = setTimeout(function() {
            intervalId = setInterval(function() {
              viewData.rotation.deg -= 0.5;
              jQuery('input[name=direct-input-rotation]').val(viewData.rotation.deg.toFixed(1).replace('.', ','));
              redraw();
            }, 100);
          }, 400);
        })
        .bind('mouseup mouseleave', function() {
          clearInterval(intervalId);
          clearTimeout(timeoutId);
        });

      jQuery('#zoom-in').bind('click', function() {
        // mindist = mindist / zoomMultiplier;
        applyZoom('in');
      });

      jQuery('#zoom-out').bind('click', function() {
        // mindist = mindist * zoomMultiplier;
        applyZoom('out');
      });

      var spaceKeyDown = false;
      jQuery('#canvas').bind('mousewheel DOMMouseScroll', function(ev) {
        if (spaceKeyDown) {
          ev.stopPropagation();
          ev.preventDefault();
          var scrollDelta = ev.originalEvent.wheelDelta || -ev.originalEvent.detail; // for FF compability
          if (scrollDelta > 0) {
            var mousepos = { x: ev.pageX - container_position.x, y: ev.pageY - container_position.y };
            applyZoom('in', mousepos);
          } else if (scrollDelta < 0) {
            var mousepos = { x: ev.pageX - container_position.x, y: ev.pageY - container_position.y };
            applyZoom('out', mousepos);
          }
        }
      });

      jQuery('input[name=direct-input-rotation]').keyup(function(e) {
        var input = jQuery(this)
          .val()
          .replace(/,/g, '.');
        if (!isNaN(parseFloat(input))) {
          viewData.rotation.deg = parseFloat(input);
        } else {
          viewData.rotation.deg = 0.0;
        }
        redraw();
      });

      jQuery(document).keydown(function(e) {
        if (jQuery('#draw-section:hover').length) {
          switch (e.which) {
            case 32: // SPACE
              e.preventDefault();
              spaceKeyDown = true;
              break;
            case 27: //ESC
              e.preventDefault();
              break;
            case 38: //UP
              e.preventDefault();
              viewData.pan.y += -2;
              redraw();
              break;
            case 40: //DOWN
              e.preventDefault();
              viewData.pan.y += 2;
              redraw();
              break;
            case 37: //LEFT
              e.preventDefault();
              viewData.pan.x += -2;
              redraw();
              break;
            case 39: //RIGHT
              e.preventDefault();
              viewData.pan.x += 2;
              redraw();
              break;
          }
          // console.log("key id",e.which);
        }
      });

      jQuery(document).keyup(function(e) {
        if (e.which === 32) {
          if (selectedTool === 'mover') {
            jQuery('#draw-tool').click();
          }
          spaceKeyDown = false;
        }
      });

      jQuery('.tp_rotation .btn-next').bind('click', function(e) {
        jQuery('input[name=rotationViewData]').val(JSON.stringify(viewData));
        jQuery('form[name=form_vorlage_rotation]').submit();
      });
    });
  });
};
